<ng-container [formGroup]="editorForm">
  <label
    class="label-padding"
    *ngIf="actualConfig.label != null && actualConfig.label != ' '">
    {{ actualConfig.label | abpLocalization }}
  </label>

  <span *ngIf="totalCount === 0">{{ '::NoItemsFound' | abpLocalization }}</span>

  <ng-container *ngFor="let item of pagedLanguages">
    <div class="form-check">
      <input
        [id]="'customerLanguage-' + item.code"
        class="form-check-input me-0"
        type="checkbox"
        [value]="item.code"
        (change)="onCheckChanged($event, item)"
        [checked]="isChecked(item)" />
      <label class="form-check-label" [for]="'customerLanguage-' + item.code">
        {{ item.name }}
      </label>
    </div>
  </ng-container>

  <mat-paginator
    *ngIf="totalCount > pageSize"
    style="display: flex; justify-content: left"
    [length]="totalCount"
    [pageSize]="pageSize"
    [pageIndex]="currentPage - 1"
    (page)="onPageChange($event)"
    hidePageSize
    showFirstLastButtons></mat-paginator>
</ng-container>
